import { ASSISTANT_LINE_SEPARATOR, ESCAPED_TRANSLATION_NEWLINE_PATTERN } from "../../onboardingAgentConstants";

export const normalizeTranslationNewlines = (value: string): string =>
    value.replace(ESCAPED_TRANSLATION_NEWLINE_PATTERN, ASSISTANT_LINE_SEPARATOR);
